import {computed, Injectable, Signal} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {UserService} from '../../shared/services/user.service';
import {Observable, ReplaySubject} from 'rxjs';
import {User, UserPermissions} from '../../shared/models/user.model';


@Injectable()
export class UserState {

  private userPermissions: ReplaySubject<UserPermissions> = new ReplaySubject<UserPermissions>(1);
  private loggedInUser: ReplaySubject<User> = new ReplaySubject<User>(1);

  // Signal-based read API alongside the Observable one above. Use these for synchronous reads
  // where the data is already loaded by the time it's read (e.g. conditional rendering of admin
  // controls). Use the Observable API for streaming or load-timing-sensitive consumers.
  public readonly loggedInUserSignal: Signal<User | undefined> = toSignal(this.loggedInUser);
  public readonly userPermissionsSignal: Signal<UserPermissions | undefined> = toSignal(this.userPermissions);
  public readonly isSuperAdmin: Signal<boolean> = computed(
    () => this.userPermissionsSignal()?.isSuperAdmin === true,
  );

  public constructor(
    private userService: UserService,
  ) {
    this.refreshState();
  }

  public refreshState() {
    this.userService.getProfile().subscribe(
      user => {
        this.loggedInUser.next(user);
        this.userPermissions.next(user.meta.permissions);
      }
    );
  }

  public getUserPermissions(): Observable<UserPermissions> {
    return this.userPermissions;
  }

  public getLoggedInUser(): Observable<User> {
    return this.loggedInUser;
  }

}
